import React from 'react';
import Immutable, { List } from 'immutable';
import { ProjectGroup } from 'records/ProjectGroup';
import AssigneeItem from './AssigneeItem';

interface Props {
  options: List<ProjectGroup>;
  selectedOptions: Immutable.OrderedSet<string>;
  handleAddSelected: (option: string) => void;
}

const GroupAssigneesTab: React.FC<Props> = (props: Props) => {
  const { options, selectedOptions, handleAddSelected } = props;

  const filteredOptions = options
    .filter((option) => !selectedOptions.includes(option.groupid))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      {filteredOptions.map((option) => (
        <AssigneeItem
          handleAddSelected={handleAddSelected}
          option={option.groupid}
          key={option.groupid}
          displayName={option.name}
        />
      ))}
    </>
  );
};
export default GroupAssigneesTab;
